import {
  SCHEDULES_COLLECTION_ADD,
  SCHEDULES_COLLECTION_CLEAR,
  SCHEDULES_COLLECTION_DELETE,
  SCHEDULES_COLLECTION_GET,
  SCHEDULES_COLLECTION_UPDATE,
} from '../actions/actionTypes';

const initialState = [];

const schedulesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCHEDULES_COLLECTION_ADD:
      return [...state, action.schedule];
    case SCHEDULES_COLLECTION_UPDATE:
      return state.map((item) => {
        if (item.id === action.schedule.id) {
          return action.schedule;
        }
        return item;
      });
    case SCHEDULES_COLLECTION_DELETE:
      return state.filter((item) => item.id !== action.value);
    case SCHEDULES_COLLECTION_GET:
      return action.value;
    case SCHEDULES_COLLECTION_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default schedulesReducer;
